const CampaignStatus = {
  Upcoming: "upcoming",
  Ongoing: "ongoing",
  Ended: "ended",
  Canceled: "cancelled",
  Cancelled: "cancelled",
};

export default CampaignStatus;
